var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailBenefitBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1191_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.1168C0 12.4977 0.292969 12.7809 0.703125 12.7809H6.2207L3.31055 20.6911C2.92969 21.6969 3.97461 22.234 4.62891 21.4137L13.5059 10.32C13.6719 10.1149 13.7598 9.91958 13.7598 9.69497C13.7598 9.32388 13.4668 9.03091 13.0566 9.03091H7.53906L10.4492 1.12075C10.8301 0.114895 9.78516 -0.422214 9.13086 0.407864L0.253906 11.4918C0.0878906 11.7067 0 11.902 0 12.1168Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailBenefitBolt);
export default __webpack_public_path__ + "static/media/gmail_benefit_bolt.8cc6334841da6ccb12aafa85d75f877d.svg";
export { ForwardRef as ReactComponent };